import Global from '../scripts/Global'
import SessionManger from '../Manager/Session.manager'
import ChannelNotification from '../Manager/Notification/Channel.manager'
import Socket from '../classes/WebSocket'
import VueSignals from '../scripts/VueSignals';

let lastNotifyTypingTimeStamp = ''
export default class TypingHandler {
  constructor(){
  }

  static Notify(){
    if((new Date().getTime() - lastNotifyTypingTimeStamp) > 5000){      
     ChannelNotification.Typying(SessionManger.getActiveChannel().channel_id,
                                 SessionManger.getActiveChannel().user_ids)
     lastNotifyTypingTimeStamp =  new Date().getTime();
    }
  }

  static stopTyping(data){
      setTimeout(function(){
        Global.globalValue(VueSignals.STOP_SEND_TYPYING_SIGNAL, data);
      }
      , 5000);
  }
}
